<template>
<div>
    <trademark-agenda-report></trademark-agenda-report>
</div>
</template>

  
<script>
export default {}
</script>
